import { IAs2Partner } from '@core/models/as2-message.model';
import { IIntegrationStatus } from '@core/models/integration.model';

export type PartnerRouteNames = {
    testOutbound: string;
    prodOutbound: string;
    testInbound: string;
    prodInbound: string;
};

export function buildPartnerOnboardingText(
    status: IIntegrationStatus | null,
    partners: IAs2Partner[],
    routes: PartnerRouteNames,
    wizardFields: {
        partnerGroupCode: string;
        as2Id: string;
        as2UrlTest: string;
        as2UrlProd: string;
        openas2PartnerName: string;
        contactEmail: string;
    }
): string {
    const lines: string[] = [
        '=== Antar AS2 onboarding packet (production) ===',
        '',
        '--- Give partners (inbound to Antar) ---',
        `PRODUCTION inbound URL: ${status?.as2InboundUrlProd || '(configure AS2 on server)'}`,
        `Antar PRODUCTION AS2 ID: ${status?.as2LocalIdProd || 'ANTAR-AS2'}`,
        `Pre-go-live TEST inbound URL: ${status?.as2InboundUrlTest || '(optional)'}`,
        `Antar TEST AS2 ID (pre-go-live): ${status?.as2LocalIdTest || 'ANTAR-AS2-TEST'}`,
        'Download Antar public certificate from admin (production partner — Download reference certificate).',
        '',
        '--- Partner configuration (Antar sends to you) ---',
        `Production group: ${wizardFields.partnerGroupCode}`,
        `Partner AS2 ID: ${wizardFields.as2Id}`,
        `OpenAS2 partner name: ${wizardFields.openas2PartnerName}`,
        `PRODUCTION receive URL: ${wizardFields.as2UrlProd}`,
        `Pre-go-live TEST receive URL: ${wizardFields.as2UrlTest}`,
        `Contact: ${wizardFields.contactEmail}`,
        '',
        '--- OpenAS2 route names (auto-generated) ---',
        `PROD outbound: ${routes.prodOutbound}`,
        `PROD inbound: ${routes.prodInbound}`,
        `TEST outbound (pre-go-live): ${routes.testOutbound}`,
        `TEST inbound (pre-go-live): ${routes.testInbound}`,
        '',
        '--- Partner codes ---',
    ];
    for (const p of partners) {
        lines.push(`${p.code} (${p.environment || 'PROD'}): enabled=${p.enabled ? 'yes' : 'no'}, as2Id=${p.as2Id}`);
    }
    return lines.join('\n');
}
